import { OrganizationRosterEntrySource } from '@/analytics/enums/organization.enums'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'
import { AnalyticsEvent, AnalyticsEventProperties } from '@/analytics/schema/events.schema'
import type { UserAccountData } from '@/firebase/auth/user-account-data'

const kOrganizationRosterEntrySources = new Set<string>(Object.values(OrganizationRosterEntrySource))

type OrganizationAnalyticsEvent =
  | AnalyticsEvent.OrganizationRosterOpened
  | AnalyticsEvent.OrganizationInviteAccepted
  | AnalyticsEvent.OrganizationUserRemoved
  | AnalyticsEvent.OrganizationLeft

/**
 * Organization id for Organization* analytics events.
 *
 * Uses `orgData.id` only — the same join key as `getCollaborationOrganizationId` and
 * `getDriveSyncOrganizationId`. Do not fall back to the legacy Drive-compatible organization ID.
 */
export function getOrganizationAnalyticsId(userAccountData: UserAccountData | null | undefined): string {
  return userAccountData?.orgData?.id ?? ''
}

/** Accepts the plain-string location.state value; unknown/missing → Unknown. Does not guess. */
export function resolveOrganizationRosterEntrySource(source: string | null | undefined): OrganizationRosterEntrySource {
  if (source != null && kOrganizationRosterEntrySources.has(source)) {
    return source as OrganizationRosterEntrySource
  }
  return OrganizationRosterEntrySource.Unknown
}

export function trackOrganizationEvent<T extends OrganizationAnalyticsEvent>(
  track: TrackEventFn | undefined,
  event: T,
  properties: AnalyticsEventProperties[T]
): void {
  if (!track) return
  try {
    track(event, properties)
  } catch {
    // Observational only — delivery must not affect org product control-flow.
  }
}
